<template>
  <div>
    <Back-top :height="100" :bottom="200">
      <div class="back-to-box">
        <p class="back-to-top visible back-to-top2">
          <Icon type="chatbubbles"></Icon>
          <span>客服</span>
          <dev class="qrcode">
            <img class="banner" :src="configObj.customerServiceImage | qiniuResource" />
          </dev>
        </p>
        <br />
        <p class="back-to-top visible">
          <Icon type="ios-arrow-up"></Icon>
          <span>TOP<br>返回顶部</span>
        </p>
      </div>
    </Back-top>
  </div>
</template>

<script>
export default {
  name: 'CustomerService',
  props: ['configObj'],
  data() {
    return {

    };
  }
};
</script>

<style scoped>
.back-to-box {
  position: fixed;
  right: 30px;
  bottom: 30px;
}

.back-to-top {
  width: 60px;
  height: 80px;
  background: #E50012;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  opacity: 0;
  visibility: hidden;
  transition: all 300ms;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 999;
  font-size: var(--font-size-xs);
  font-weight: 600;
}

.qrcode {
  position: absolute;
  right: 80px;
  top: -20px;
  display: none;

  img {
    width: 120px;
    height: 120px;
  }
}

.back-to-top.visible {
  opacity: 1;
  visibility: visible;
}

.back-to-top:hover {
  background: #E50012;
  transform: translateY(-4px);

  .qrcode {
    display: block;
  }
}

.back-to-top i {
  font-size: 24px;
}

.back-to-top span {
  text-align: center;
  line-height: 1.2;
}

@media (max-width: 768px) {
  .back-to-top {
    width: 40px;
    height: 40px;
    font-size: 12px;

    span {
      display: none;
    }
  }

  .back-to-top2 {
    display: none;
  }

  .back-to-top i {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customerService/CustomerService.vue